/* @flow */
import React, { Component, type Node } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

type Props = {
  title: string,
  message?: string,
  handleSubmit: () => void | Promise<*>,
  renderSubmitButton: (() => void) => Node,
};

type State = {
  open: boolean,
};

export default class ConfirmDialog extends Component<Props, State> {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = () => {
    this.setState({ open: false }, () => {
      this.props.handleSubmit();
    });
  };

  handleButtonClick = () => {
    this.handleOpen();
  };

  render() {
    const { title, message = 'Are you sure?', renderSubmitButton } = this.props;

    return (
      <div>
        <Dialog
          title={title}
          open={this.state.open}
          actions={[
            <FlatButton label="Cancel" primary onClick={this.handleClose} />,
            <RaisedButton label="Submit" primary onClick={this.handleSubmit} />,
          ]}
        >
          <div>{message}</div>
        </Dialog>
        {renderSubmitButton(this.handleButtonClick)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/components/ConfirmDialog.js